import React from "react";
import { Quote, Star } from "lucide-react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { TESTIMONIALS } from "@/data/site";

export const Testimonials = () => {
  return (
    <section className="bg-surface py-24 lg:py-32" data-testid="testimonials">
      <div className="container-x">
        <SectionHeading
          align="center"
          className="mb-16"
          eyebrow="Client stories"
          title="Trusted by families & businesses alike."
        />

        <StaggerGroup className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <StaggerItem key={t.name} className="h-full">
              <figure
                className="relative h-full flex flex-col rounded-3xl bg-white border border-gray-100 p-8 shadow-soft hover:shadow-card transition-shadow duration-300"
                data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}
              >
                <Quote className="h-10 w-10 text-brand-light" />
                <div className="mt-4 flex items-center gap-1 text-brand-accent">
                  {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}
                </div>
                <blockquote className="mt-4 flex-1 text-ink leading-relaxed">&ldquo;{t.quote}&rdquo;</blockquote>
                <figcaption className="mt-6 flex items-center gap-4 pt-6 border-t border-gray-100">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white font-heading font-bold">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="font-heading font-bold text-ink">{t.name}</p>
                    <p className="text-sm text-muted-foreground">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
